import { Controller } from "@hotwired/stimulus"

// Card #3018 -- click an avatar tile in a phase project's "In Flight"
// header (client_cycles/_phase_project_assignee_summary.html.erb) to
// filter the card tiles below (client_cycles/_phase_project_cards_row.html.erb)
// down to that person's cards. Same shape as campaign_kind_filter_controller.js
// (the Deploying tab's stat-card-to-mission-table filter): click the active
// avatar again to clear back to showing everyone.
export default class extends Controller {
  static targets = ["avatar", "card"]

  connect() {
    this.activeUserId = null
  }

  filter(event) {
    event.preventDefault()
    const avatar = event.currentTarget
    const userId = avatar.dataset.userId

    if (this.activeUserId === userId) {
      // Clicking the active avatar clears the filter
      this.activeUserId = null
    } else {
      this.activeUserId = userId
    }

    this.applyFilter()
  }

  applyFilter() {
    // Update avatar highlight states
    this.avatarTargets.forEach(avatar => {
      const isActive = avatar.dataset.userId === this.activeUserId

      if (this.activeUserId === null || isActive) {
        avatar.classList.remove("opacity-40")
      } else {
        avatar.classList.add("opacity-40")
      }

      // Swap the fan-effect white separator ring for a sapphire highlight
      // ring on the active avatar -- ring-2 itself stays constant so the
      // overlap separator never disappears.
      avatar.classList.toggle("ring-sapphire", isActive)
      avatar.classList.toggle("ring-white", !isActive)
    })

    // Show/hide card tiles
    this.cardTargets.forEach(card => {
      if (this.activeUserId === null || card.dataset.userId === this.activeUserId) {
        card.classList.remove("hidden")
      } else {
        card.classList.add("hidden")
      }
    })
  }
}
